import { defineGlobalStyles } from '@chakra-ui/react'

export const globalCss = defineGlobalStyles({
  html: {
    overflow: 'hidden',
  },
  body: {},
  '::-webkit-scrollbar': {
    w: '8px',
    h: '8px',
  },
  '::-webkit-scrollbar-track, ::-webkit-scrollbar-corner': {
    bg: 'transparent',
  },
  '::-webkit-scrollbar-thumb': {
    bg: '#CBD5E0',
    _dark: {
      bg: 'rgb(113,128,150)',
    },
    borderRadius: '3px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    bg: '#A0AEC0',
    _dark: {
      bg: 'rgb(100, 111, 128)',
    },
  },
})
